// import React from "react";
// import "./ScientificNetworking.scss";
// import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
// import Section from "../Section";
// import { pageTitle } from "../../helpers/PageTitle";

// const trainingData = [
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-1" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-2" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-3" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-4" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-5" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/product-6" },
// ];

// const teamTrainingData = [
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/team-1" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/team-2" },
//   { imgUrl: "/images/home_1/devlopment.png", href: "/products/team-3" },
// ];

// export default function ScientificNetworking() {
//   pageTitle("Scientific Networking");

//   const kolEngagement = [
//     "Panel discussions",
//     "Focused group meetings",
//     "Conference symposia",
//     "Scientific newsletters"
//   ];

//   const brandPhilosophy = [
//     "One disease → one clear mechanism",
//     "No unnecessary ingredient crowding",
//     "Predictable safety for chronic use"
//   ];

//   const keyBrands = [
//     { logo: "/images/icons/cognivance.png", description: "Cognitive support & neuroprotection" },
//     { logo: "/images/icons/alzavia.png", description: "Rational dementia management" },
//     { logo: "/images/icons/riventra.png", description: "A new way to protect the integrity of BBB" },
//     { logo: "/images/icons/migrenta.png", description: "Neurovascular migraine control" },
//     { logo: "/images/icons/solvira.png", description: "Mood stabilization & emotional balance" },
//     { logo: "/images/icons/pregacel.png", description: "Neuropathic pain modulation" },
//     { logo: "/images/icons/rozucel.png", description: "Vascular risk reduction" }
//   ];

//   return (
//     <>
//       <BannerSectionStyle5
//         bgUrl="/images/about/banner_bg.jpg"
//         imgUrl="/images/about/banner_img.png"
//         title="Scientific Networking"
//         subTitle=""
//       />

//       {/* KOL Engagement & Scientific Networking */}
//       <Section topMd={80} bottomMd={60} bottomLg={40}>
//         <div className="container kol-engagement-section animate-fade-in">
//           <div className="cs_section_title cs_style2">
//             <h2 className="cs_title text-center">KOL ENGAGEMENT & SCIENTIFIC NETWORKING</h2>
//             <p className="cs_subtitle text-center">Collaborative Growth with Experts</p>
//           </div>
//           <ul className="kol-list">
//             {kolEngagement.map((item, idx) => (
//               <li key={idx} className="kol-list-item animate-slide-up">{item}</li>
//             ))}
//           </ul>
//           <p className="kol-desc text-center">
//             These engagements ensure Celbion stays aligned with <span className="highlight">real-world clinical challenges</span> and evolving medical science.
//           </p>
//         </div>
//       </Section>

//       {/* Brand Glossary & Rational Philosophy */}
//       <Section topMd={60} bottomMd={60} bottomLg={40}>
//         <div className="container brand-glossary-section animate-fade-in">
//           <div className="cs_section_title cs_style2">
//             <h2 className="cs_title text-center">Brand Glossary & Rational Philosophy</h2>
//             <p className="cs_subtitle text-center">Our Brand Development Philosophy</p>
//           </div>
//           <ul className="philosophy-list">
//             {brandPhilosophy.map((item, idx) => (
//               <li key={idx} className="philosophy-list-item animate-slide-up">{item}</li>
//             ))}
//           </ul>
//           <div className="key-brands-table">
//             <div className="key-brands-header">
//               <span className="brand-label">Key Brands</span>
//               <span className="brand-desc">Rational Approach</span>
//             </div>
//             {keyBrands.map((brand, idx) => (
//               <div className="key-brand-row animate-slide-in" key={idx}>
//                 <span className="brand-logo">
//                   <img src={brand.logo} alt="Brand Logo" style={{ height: 40, width: 'auto' }} />
//                 </span>
//                 <span className="brand-description">{brand.description}</span>
//               </div>
//             ))}
//           </div>
//           <p className="brand-note text-center">
//             Each brand is designed for <span className="highlight">long-term confidence</span>, not short-term hype.
//           </p>
//         </div>
//       </Section>
//     </>
//   );
// }


import React from "react";
import "./ScientificNetworking.scss";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

const kolEngagement = [
  "Panel discussions",
  "Focused group meetings",
  "Conference symposia",
  "Scientific newsletters",
];

const brandPhilosophy = [
  "One disease → one clear mechanism",
  "No unnecessary ingredient crowding",
  "Predictable safety for chronic use",
];

const keyBrands = [
  { logo: "/images/icons/cognivance.png",  description: "Cognitive support & neuroprotection" },
  { logo: "/images/icons/alzavia.png",     description: "Rational dementia management" },
  { logo: "/images/icons/riventra.png",    description: "A new way to protect the integrity of BBB" },
  { logo: "/images/icons/migrenta.png",    description: "Neurovascular migraine control" },
  { logo: "/images/icons/solvira.png",     description: "Mood stabilization & emotional balance" },
  { logo: "/images/icons/pregacel.png",    description: "Neuropathic pain modulation" },
  { logo: "/images/icons/rozucel.png",     description: "Vascular risk reduction" },
];

export default function ScientificNetworking() {
  pageTitle("Scientific Networking");

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="Scientific Networking"
        subTitle=""
      />

      {/* ── KOL Engagement & Scientific Networking ── */}
      <Section topMd={80} bottomMd={60} bottomLg={40}>
        <div className="container kol-engagement-section animate-fade-in">

          <span className="kol-badge">Scientific Excellence</span>

          <h2 className="kol-title">
            KOL Engagement &amp; <span>Scientific Networking</span>
          </h2>
          <p className="kol-subtitle">Collaborative Growth with Experts</p>

          <p style={{ fontSize: "0.97rem", color: "rgba(255,255,255,0.78)", marginBottom: 28, fontFamily: "'Open Sans', sans-serif", lineHeight: 1.65 }}>
            Celbion actively engages with Key Opinion Leaders (KOLs) through:
          </p>

          <ul className="kol-list">
            {kolEngagement.map((item, idx) => (
              <li
                key={idx}
                className="kol-list-item animate-slide-up"
                style={{ animationDelay: `${idx * 0.1}s` }}
              >
                {item}
              </li>
            ))}
          </ul>

          <p className="kol-desc text-center">
            These engagements ensure Celbion stays aligned with{" "}
            <span className="highlight">real-world clinical challenges</span> and
            evolving medical science.
          </p>
        </div>
      </Section>

      {/* ── Brand Glossary & Rational Philosophy ── */}
      <Section topMd={0} bottomMd={60} bottomLg={40}>
        <div className="container brand-glossary-section animate-fade-in">

          <div className="text-center" style={{ marginBottom: 32 }}>
            <span className="brand-section-label">Our Approach</span>
            <h2 className="brand-main-title">
              Brand Glossary &amp; Rational Philosophy
            </h2>
            <p className="brand-subtitle">Our Brand Development Philosophy</p>
            <p className="brand-intro">
              Celbion follows a <strong>rational, pathway-driven approach:</strong>
            </p>
          </div>

          {/* Philosophy pills */}
          <ul className="philosophy-list">
            {brandPhilosophy.map((item, idx) => (
              <li
                key={idx}
                className="philosophy-list-item animate-slide-up"
                style={{ animationDelay: `${idx * 0.12}s` }}
              >
                {item}
              </li>
            ))}
          </ul>

          {/* Key brands table */}
          <div className="key-brands-table">
            <div className="key-brands-header">
              <span>Key Brands</span>
              <span>Rational Approach</span>
            </div>

            {keyBrands.map((brand, idx) => (
              <div
                className="key-brand-row animate-slide-in"
                key={idx}
                style={{ animationDelay: `${idx * 0.08}s` }}
              >
                <span className="brand-logo-cell">
                  <img src={brand.logo} alt="Brand logo" />
                </span>
                <span className="brand-description-cell">{brand.description}</span>
              </div>
            ))}
          </div>

          <p className="brand-note text-center">
            Each brand is designed for{" "}
            <span className="highlight">long-term confidence</span>, not
            short-term hype.
          </p>
        </div>
      </Section>
    </>
  );
}